module.exports = __webpack_public_path__ + "img/ic-logo-eostre@3x.9692d005.jpg";